import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  CollectionActionEvent,
  CollectionId,
  CollectionVariant,
  DisplayCollectionEvent,
} from '../../models/collection.types';

@Component({
  selector: 'app-vehicle-collection',
  templateUrl: './vehicle-collection.component.html',
  styleUrls: ['./vehicle-collection.component.scss'],
})
export class VehicleCollectionComponent implements OnInit {
  @Input() nameCollection = '';
  @Input() typeCollection = '';
  @Input() isOpen = false;
  @Input() variant: CollectionVariant = 'operacion';
  @Input() id: CollectionId = { idOperation: 0 };
  @Output() eventDisplayCollection = new EventEmitter<DisplayCollectionEvent>();
  @Output() eventDeleteCollection = new EventEmitter<CollectionActionEvent>();
  @Output() eventEditCollection = new EventEmitter<CollectionActionEvent>();
  @Output() eventMultiviewCollection = new EventEmitter<CollectionActionEvent>();
  public isDisplay = true;
  public variantColor = '';
  private unassignedResults = ['sin operación', 'sin grupo', 'sin convoy'];

  ngOnInit(): void {
    this.variantColor = this.getHeaderClass();
  }

  toggleDetails(event: Event) {
    this.isOpen = !this.isOpen;
    if (this.isOpen && this.variant === 'convoy') {
      if (!this.variantColor.includes('header_open')) {
        this.variantColor += ' header_open';
      }
    } else {
      this.variantColor = this.variantColor.replace('header_open', '').trim();
    }
    event.stopPropagation();
  }

  stopEvent(event: Event) {
    event.stopPropagation();
  }

  getHeaderClass(): string {
    switch (this.variant) {
      case 'operacion':
        return 'header_v1 header_operation';
      case 'grupo':
        return 'header_v2';
      case 'convoy':
        return 'header_v3';
      default:
        return 'header_v1';
    }
  }

  isUnassigned(): boolean {
    const normalizedTypeCollection = this.typeCollection.toLowerCase();
    return this.unassignedResults.includes(normalizedTypeCollection);
  }

  changeDisplay() {
    this.isDisplay = !this.isDisplay;
    this.eventDisplayCollection.emit({
      id: { ...this.id },
      variant: this.variant,
      isShow: this.isDisplay,
    });
  }

  showDelete() {
    this.eventDeleteCollection.emit({
      id: { ...this.id },
      variant: this.variant,
      nameVariant: this.typeCollection,
    });
  }

  showEditGroup() {
    this.eventEditCollection.emit({
      id: { ...this.id },
      variant: this.variant,
      nameVariant: this.typeCollection,
    });
  }

  showMultiview() {
    this.eventMultiviewCollection.emit({
      id: { ...this.id },
      variant: this.variant,
      nameVariant: this.typeCollection,
    });
  }
}
